<template>
  <button class="c-filter-button" :class="classList" @click="toggleFilter">
    {{ name }}
    <svg class="c-filter-button__icon" aria-hidden="true" focusable="false">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#filter"></use>
    </svg>
  </button>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      classList: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        isFilterOpen: false,
      }
    },
    methods: {
      toggleFilter() {
        this.isFilterOpen = !this.isFilterOpen
        this.$emit('clicked', this.isFilterOpen)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/_filter/filter-button/FilterButton.vue